import { styled } from "@mui/material/styles";
import { FontSize300, TypeFontT3MobileLineHeight, FontSize400, TypeFontT3DesktopLineHeight, FontWeightBold } from "@nxt-costco-com/forge-design-tokens";
import { DEFAULT_TILE_TOP_TEXT_COLOR, DEFAULT_TILE_BOTTOM_TEXT_COLOR } from "../constants.js";
const RowContainer = styled("li")`
    align-items: center;
    display: flex;
    flex-direction: row;
    margin-bottom: 8px;
    padding: 0;
`;
const TopTitle = styled("dt")`
    @media (max-width: 768px) : {
        font-size: ${FontSize300};
        line-height: ${TypeFontT3MobileLineHeight};
    }
    color: ${(props) => props.color || DEFAULT_TILE_TOP_TEXT_COLOR};
    font-size: ${FontSize400};
    line-height: ${TypeFontT3DesktopLineHeight};
    margin: 0;
    text-align: center;
`;
const SecondaryTitle = styled("dd")`
    @media (max-width: 768px): {
        font-size: 20px;
        line-height: 24px;
    },
    color: ${(props) => props.color || DEFAULT_TILE_BOTTOM_TEXT_COLOR};
    font-size: 21px;
    font-weight: ${FontWeightBold};
    margin: 0;
    text-align: center;
`;
export {
  RowContainer,
  SecondaryTitle,
  TopTitle
};
